import { Grid } from '@mui/material';
import { FC } from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  DateTimeInput,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  required,
  ReferenceInput,
  FormDataConsumer,
} from 'react-admin';

const transformData = (data: any) => {
  // if (Array.isArray(data.blocks)) {
  //   data.blocks = data.blocks.map((block: any, index: number) => ({
  //     ...block,
  //     position: index + 1,
  //   }));
  // }
  // if (Array.isArray(data.author.urls)) {
  //   data.author.urls = data.author.urls.map((block: any, index: number) => ({
  //     ...block,
  //     position: index + 1,
  //   }));
  // }
  // if (Array.isArray(data.material_urls)) {
  //   data.material_urls = data.material_urls.map(
  //     (block: any, index: number) => ({
  //       ...block,
  //       position: index + 1,
  //     })
  //   );
  // }
  return data;
};

export const MaterialTestsCreate = (props: any) => (
  <Create {...props} transform={transformData}>
    <SimpleForm>
      {/* Основные поля материала */}
      {/* <TextInput source="feed_id" label="Feed ID" validate={required()} /> */}
      <ReferenceInput source="feed_id" reference="feeds" label="Лента">
        <SelectInput source="id" label="Лента" fullWidth optionText="name" />
      </ReferenceInput>
      <TextInput
        source="name"
        label="Название"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="url"
        label="Адрес (example_page_link)"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="url_img"
        label="Ссылка на изображение"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="text"
        fullWidth
        minRows={3}
        maxRows={10}
        label="Текст перед тестом"
        multiline
      />
      <NumberInput
        source="count_ok"
        label="Количество ответов для прохождения"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="message_success_title"
        label="Заголовок при прохождении"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="message_success_text"
        label="Текст при прохождении"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="message_fail_title"
        label="Заголовок при неудаче"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="message_fail_text"
        label="Текст при неудаче"
        fullWidth
        validate={required()}
      />

      <h3>Вопросы</h3>
      {/* Блоки */}
      <ArrayInput source="questions" label="Вопросы">
        <SimpleFormIterator>
          <NumberInput
            source="position"
            label="Позиция"
            style={{ display: 'none' }}
          />
          <TextInput source="id" style={{ display: 'none' }} />
          <SelectInput
            fullWidth
            source="type"
            label="Тип контента"
            choices={[
              { id: 'one', name: 'Один вариант' },
              { id: 'multiply', name: 'Много вариантов' },
              { id: 'text', name: 'Текст' },
            ]}
            validate={required()}
          />
          <TextInput
            source="question"
            label="Вопрос"
            fullWidth
            validate={required()}
          />
          <FormDataConsumer>
            {({ scopedFormData, getSource }) =>
              scopedFormData &&
              scopedFormData.type !== 'text' && (
                <ArrayInput source={getSource('answers')} label="Ответы">
                  <SimpleFormIterator inline>
                    <TextInput source="id" style={{ display: 'none' }} />
                    <TextInput
                      source={getSource('answer')}
                      label="Ответ"
                      validate={required()}
                    />
                    <BooleanInput source="is_correct" label="Верный" />
                  </SimpleFormIterator>
                </ArrayInput>
              )
            }
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);
